import React from "react";
import { Link } from "react-router-dom";

class JobListing extends React.Component {
  render() {
    return (
      <div>
        <div id="circular-menu" className="circular-menu">
          <a className="floating-btn">
            <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
            <i aria-hidden="true" className="fa fa-times"></i>
          </a>

          <div className="items-wrapper">
            <div className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </div>
            <a
              className="menu-item is-flex right-panel-trigger"
              data-panel="languages-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </a>
            <Link to="" className="menu-item is-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bell"
              >
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
            </Link>
            <a
              className="menu-item is-flex right-panel-trigger"
              data-panel="activity-panel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-grid"
              >
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
            </a>
          </div>
        </div>
        {/* <!-- row --> */}
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-xl-8"> */}
             
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body ">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="coursefilter">
                          
                          <div className="accordion" id="accordionExample">
                            <div className="accordion-item">
                              <h2
                                className="accordion-header"
                                id="headingThree"
                              >
                                <button
                                  className="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFour"
                                  aria-expanded="true"
                                  aria-controls="collapseFour"
                                >
                                  Role
                                </button>
                              </h2>
                              <div
                                id="collapseFour"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingFour"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="number"
                                      className="form-control searchtype"
                                    />
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>Software Developer</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>Sr. Software Developer</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="three"
                                      name="fav_language"
                                      value="THREE"
                                    />
                                    <span>Data Engineer</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="four"
                                      name="fav_language"
                                      value="FOUR"
                                    />
                                    <span>Sr. Data Engineer</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingTwo">
                                <button
                                  className="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseTwo"
                                  aria-expanded="true"
                                  aria-controls="collapseTwo"
                                >
                                  Skills
                                </button>
                              </h2>
                              <div
                                id="collapseTwo"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>Web Development (523)</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>Wordpress (778)</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="three"
                                      name="fav_language"
                                      value="THREE"
                                    />
                                    <span>Javascript (133)</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="four"
                                      name="fav_language"
                                      value="FOUR"
                                    />
                                    <span>Graphic Design (123)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          
                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingFive">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFive"
                                  aria-expanded="false"
                                  aria-controls="collapseFive"
                                >
                                  Location
                                </button>
                              </h2>
                              <div
                                id="collapseFive"
                                className="accordion-collapse collapse"
                                aria-labelledby="headingFive"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>Delhi NCR</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>Mumbai</span>
                                  </div>

                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>Bangalore</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>Pune</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingFive">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFive"
                                  aria-expanded="false"
                                  aria-controls="collapseFive"
                                >
                                  Experience Required
                                </button>
                              </h2>
                              <div
                                id="collapseFive"
                                className="accordion-collapse collapse"
                                aria-labelledby="headingFive"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>Fresher</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>0-2</span>
                                  </div>

                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>2-5</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>Above 5</span>
                                  </div>
                                </div>
                              </div>
                            </div>


                             <div className="accordion-item">
                              <h2 className="accordion-header" id="headingFive">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFive"
                                  aria-expanded="false"
                                  aria-controls="collapseFive"
                                >
                                  Priority
                                </button>
                              </h2>
                              <div
                                id="collapseFive"
                                className="accordion-collapse collapse"
                                aria-labelledby="headingFive"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>High</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>Medium</span>
                                  </div>

                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>Low</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>Lesser</span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="accordion-item">
                              <h2 className="accordion-header" id="headingSix">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseSix"
                                  aria-expanded="false"
                                  aria-controls="collapseSix"
                                >
                                  Status
                                </button>
                              </h2>
                              <div
                                id="collapseSix"
                                className="accordion-collapse collapse"
                                aria-labelledby="headingSix"
                                data-bs-parent="#accordionExample"
                              >
                                <div className="accordion-body">
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="one"
                                      name="fav_language"
                                      value="ONE"
                                    />
                                    <span>Open</span>
                                  </div>
                                  <div className="filterdiv-accordion">
                                    <input
                                      type="checkbox"
                                      id="two"
                                      name="fav_language"
                                      value="TWO"
                                    />
                                    <span>Closed</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-9 pl-0">
                        <div className="custom-tab-1 latest-recruitment02">
                          <strong className="upcomehead">
                            Current positions (4 positions found)
                          </strong>
                          <div className="tab-content">
                            <div className="shortlisted">
                              <div className="tab-content">
                                <div
                                  id=""
                                  className="tab-pane fade active show"
                                >
                                  <div className="profile-about-me">
                                    <div className="boxs">
                                      <Link to="PositionDetails">
                                        <div className="setposition">
                                          <p className="">Posted 08 Oct 2023</p>
                                          <strong>
                                            Sr. Software Engineer - iOS
                                          </strong>
                                          <p className="">
                                            Job # : <b>54254</b>
                                          </p>
                                          <ul>
                                            <li>
                                              <img src="images/org-img/recruitment/exp.svg" />
                                              Experience :<b>4-8 Yrs</b>{" "}
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/location.svg" />
                                              Location : <b>Noida</b>
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/priority.svg" />
                                              Priority : <b>High</b>
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/opening.svg" />
                                              Opening : <b>02</b>
                                            </li>
                                          </ul>
                                          <i className="openpost">
                                            <span></span>Open
                                          </i>
                                          <a href="" className="editpost">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-pencil"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                            </svg>
                                          </a>
                                        </div>
                                      </Link>
                                    </div>
                                    <div className="boxs">
                                      <Link to="RecruitmentDetails">
                                        <div className="setposition">
                                          <p className="">Posted 08 Oct 2023</p>
                                          <strong>Sr. Content Writer</strong>
                                          <p className="">
                                            Job # : <b>54254</b>
                                          </p>
                                          <ul>
                                            <li>
                                              <img src="images/org-img/recruitment/exp.svg" />
                                              Experience:<b>4-8 Yrs</b>{" "}
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/location.svg" />
                                              Location: <b>Noida</b>
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/priority.svg" />
                                              Priority: <b>High</b>
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/opening.svg" />
                                              Opening: <b>00</b>
                                            </li>
                                          </ul>
                                          <i className="closepost">
                                            <span></span>Closed
                                          </i>
                                          <a href="" className="editpost">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-pencil"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                            </svg>
                                          </a>
                                        </div>
                                      </Link>
                                    </div>
                                    <div className="boxs">
                                      <Link to="RecruitmentDetails">
                                        <div className="setposition">
                                          <p className="">Posted 08 Oct 2023</p>
                                          <strong>
                                            Graphic Cum Web Designer
                                          </strong>
                                          <p className="">
                                            Job # : <b>54254</b>
                                          </p>
                                          <ul>
                                            <li>
                                              <img src="images/org-img/recruitment/exp.svg" />
                                              Experience :<b>4-8 Yrs</b>{" "}
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/location.svg" />
                                              Location : <b>Noida</b>
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/priority.svg" />
                                              Priority : <b>High</b>
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/opening.svg" />
                                              Opening : <b>02</b>
                                            </li>
                                          </ul>
                                          <i className="openpost">
                                            <span></span>Open
                                          </i>
                                          <a href="" className="editpost">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-pencil"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                            </svg>
                                          </a>
                                        </div>
                                      </Link>
                                    </div>
                                    <div className="boxs">
                                      <Link to="RecruitmentDetails">
                                        <div className="setposition">
                                          <p className="">Posted 08 Oct 2023</p>
                                          <strong>
                                            Search Engine Optimization (SEO)
                                          </strong>
                                          <p className="">
                                            Job # : <b>54254</b>
                                          </p>
                                          <ul>
                                            <li>
                                              <img src="images/org-img/recruitment/exp.svg" />
                                              Experience :<b>4-8 Yrs</b>{" "}
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/location.svg" />
                                              Location : <b>Noida</b>
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/priority.svg" />
                                              Priority : <b>High</b>
                                            </li>
                                            <li>
                                              <img src="images/org-img/recruitment/opening.svg" />
                                              Opening : <b>02</b>
                                            </li>
                                          </ul>
                                          <i className="openpost">
                                            <span></span>Open
                                          </i>
                                          <a href="" className="editpost">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-pencil"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                            </svg>
                                          </a>
                                        </div>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {/* </div> */}

            {/* <div className="col-xl-4">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body ">
                      <div className="shortlisted">
                        <strong className="upcome">Recent Search</strong>
                        <div className="tab-content">
                          <div>
                            <div className="interviewee accordion">
                              <div className="boxs">
                                <p>
                                  You have not done any activity in last 5 days
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body ">
                      <div className="custom-tab-1 latest-recruitment">
                        <strong className="upcome">Saved Search</strong>
                        <Link to="" className="more-icon">
                          <i className="fa fa-angle-right"></i>
                        </Link>
                        <div className="tab-content">
                          <div id="" className="tab-pane fade active show">
                            <div className="profile-about-me">
                              <div className="boxs">
                                <div>
                                  <p className="">Offered on 08 Oct 2023</p>
                                  <strong>Sunita Kashyap</strong>
                                  <ul>
                                    <li>
                                      <img src="images/org-img/recruitment/exp.svg" />
                                      Senior Android Developer
                                    </li>
                                    <li>
                                      <img src="images/org-img/recruitment/location.svg" />
                                      Noida{" "}
                                    </li>
                                    <li>
                                      <img src="images/org-img/recruitment/priority.svg" />{" "}
                                      52.5K
                                    </li>
                                  </ul>
                                  <a href="">
                                    <b>100 + new profile</b>
                                  </a>
                                </div>
                              </div>
                              <div className="boxs">
                                <div>
                                  <p className="">Offered on 08 Oct 2023</p>
                                  <strong>Kanak Sharma</strong>
                                  <ul>
                                    <li>
                                      <img src="images/org-img/recruitment/exp.svg" />
                                      Web Developer
                                    </li>
                                    <li>
                                      <img src="images/org-img/recruitment/location.svg" />
                                      Delhi{" "}
                                    </li>
                                    <li>
                                      <img src="images/org-img/recruitment/priority.svg" />
                                      70.5K
                                    </li>
                                  </ul>
                                  <a href="">
                                    <b>70 + new profile</b>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="modal fade" id="contact-manager">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title m-auto">
                  Contact Your Reporting Manager htmlFor Any Leave
                  Clarifications
                </h5>
              </div>
              <div className="modal-body text-center">
                <form>
                  <div className="form-group text-left">
                    <label>Repoting Manager</label>
                    <select className="default-select form-control wide mb-3">
                      <option selected disabled>
                        Select reporting manager
                      </option>
                      <option>Arun Mishra</option>
                      <option>Pragya Tiwari</option>
                      <option>Alisha Goyal</option>
                    </select>
                  </div>
                  <div className="form-group text-left">
                    <label className="mt-3">Reason</label>
                    <textarea
                      rows="4"
                      cols="1"
                      className="form-control"
                    ></textarea>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger light"
                  data-bs-dismiss="modal"
                >
                  Decline
                </button>
                <button type="button" className="btn btn-primary">
                  Accept
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default JobListing;
